import { House, Sparkles, Settings } from "lucide-react";
import { NavLink, Outlet } from "react-router-dom";
import { Logo } from "./Logo";
import { useAuth } from "../AuthContext";

const navigation = [
  { to: "/app", label: "Inicio", icon: House, end: true },
  { to: "/app/ai", label: "Copiloto IA", icon: Sparkles },
  { to: "/app/profile", label: "Ajustes", icon: Settings },
];

export function AppShell() {
  const { account } = useAuth();
  return (
    <div className="app-frame">
      <header className="app-header">
        <Logo compact />
        <div className="header-license">
          <span className={account?.license?.status === "active" ? "status-dot active" : "status-dot"} />
          {account?.license?.status === "active" ? "XR4 activo" : "Sin activar"}
        </div>
      </header>
      <main className="app-content"><Outlet /></main>
      <nav className="bottom-nav" aria-label="Navegación principal">
        {navigation.map(({ to, label, icon: Icon, end }) => (
          <NavLink key={to} to={to} end={end} className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
            <Icon size={21} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
